"use client"
import React, { useState, useEffect, useRef } from "react";
import styles from "./SiteMapPage.module.css"
import dynamic from 'next/dynamic';
const Header = dynamic(() => import('@/Component/Header'), { ssr: false });
const TitleText = dynamic(() => import('@/Component/TitleText'), { ssr: false });
import Footer, { textData} from "@/Component/Footer";
import { useTranslation } from "react-i18next";
import { accordion,OnOpenUrl } from "@/Component/accordion";
import {useRouter} from "next/navigation";
const Row = ({ accordionData }) => {
    const { t } = useTranslation();
    const router = useRouter();
    return (
        <div className={styles.row}>
            <span className={styles.row__title__text}>
                {t(accordionData.nameKey)}
            </span>

            {accordionData.content &&
                <div className={styles.row__detail}>
                    <div className={styles.row__depth2}>
                        {accordionData.content.map((item, index) => (
                            <span key={index} className={styles.row__detail__text} onClick={() => OnOpenUrl({content : item, navigate : router})}>
                                {t(item.nameKey)}
                            </span>
                        ))}
                    </div>
                </div>
            }
        </div>
    );
}

const SiteMapPage = () => {
    const [items, setItems] = useState(accordion);
    const hasAdded = useRef(false);

    useEffect(() => {
        if (!hasAdded.current) {
            const initalizedItems = [{ nameKey: "SiteMap.Main.TItle" }, ...items];

            const footerItems = [
                {
                    nameKey: "Footer.Family",
                    content:[
                        {
                            nameKey:"Footer.FamilySite.Btb",
                            url : "https://store.btb.bepex.xyz/"
                        }

                    ]
                },
                {
                    nameKey:"SiteMap.Vision.TItle",
                    content:[
                        textData[0]
                    ]
                },
                {
                    nameKey : "SiteMap.Policy.Title",
                    content:[
                        textData[2],textData[3]
                    ]
                }

            ];
            initalizedItems.push(...footerItems)
            setItems(initalizedItems);
            hasAdded.current = true;
            
        }
    }, []);
    return (
        <div className={styles.page}>
            <Header></Header>
            <TitleText titleTextInfo={{ textKey: "Footer.SiteMap" }}></TitleText>
            <div className={styles.container}>
                <div className={styles.content}>
                    {items.map((item, index) => (
                        <Row key={index} accordionData={item}>

                        </Row>
                    ))}
                </div>
            </div>
            <Footer></Footer>
        </div>
    );
}


export default SiteMapPage;